var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (!selectedStore) return;
  var storeId = selectedStore.storeID;
  
  var t = new Date()
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentyear = t.getFullYear();
  var weekDay = t.getDay();
  var currentHour = t.getHours()
  console.log({storeId})
  
  switch (storeId) {
    // Sorauren   
    case 1573:
      if (weekDay === 0 && currentHour >= 15) {
		picker.set('min', 2)
      }
      break;
      
    // Annette   
    case 1268:
      if (weekDay === 2 && currentHour >= 15) {
		picker.set('min', 2)
      }
      break;
      
    // Wychwood   
    case 6419:
      if (weekDay === 5 && currentHour >= 8) {
		picker.set('min', 2)
      }
      break;
    
    // Brickworks   
    case 5404:
      if (weekDay === 5 && currentHour >= 8) {
		picker.set('min', 2)
      }
      break;
      
    //Leslieville   
    case 54:
      if (weekDay === 6 && currentHour >= 9) {
		picker.set('min', 2)
      }
      break;
     
    // Lakeview   
    case 9789:
      if (weekDay === 6 && currentHour >= 9) {
		picker.set('min', 2)
      }
      break;
  }
  
  picker.set('disable', blackoutdatesCollection);
}
